'use strict';

import Component from '_core_ext/components/Component';
import util from '_core_ext/util';

export default class NavSlider extends Component {
    init() {
        super.init();
        this.initCache();

        this.event('click', '.js-slider-level2', this.showLevel2);
        this.event('click', '.js-slider-level2-category', this.triggerNextSlider);

        $(document).on('keydown', (e) => this.handleKeydown(e));
        this.setNextFocusElement();
    }

    getActiveMenuItems() {
        var menuItems = [];

        if (this.level2MenuActive) {
            menuItems = $('.js-hamburger-menu-level-2').find('button, a');
        } else if (this.level3MenuActive) {
            menuItems = $('.js-hamburger-menu-level-3').find('button, a');
        } else {
            menuItems = this.mainMenuItems;
        }

        return menuItems;
    }

    setFocusElement(element) {
        if (this.level2MenuActive) {
            this.level2FocusedElement = element;
        } else if (!this.level3MenuActive) {
            this.level1FocusedElement = element;
        }
        element.focus();
    }

    setNextFocusElement() {
        const menuItems = this.getActiveMenuItems();
        const currentIndex = Array.from(menuItems).indexOf(document.activeElement);
        const nextIndex = (currentIndex + 1) % menuItems.length;
        this.setFocusElement(menuItems[nextIndex]);
    }

    setPreviousFocusElement() {
        const menuItems = this.getActiveMenuItems();
        const currentIndex = Array.from(menuItems).indexOf(document.activeElement);
        const previousIndex = (currentIndex - 1 + menuItems.length) % menuItems.length;
        this.setFocusElement(menuItems[previousIndex]);
    }

    // eslint-disable-next-line complexity
    handleKeydown(e) {
        if (!$('body').hasClass('nav-active')) { return; }
        var $activeElement = $(document.activeElement);

        switch (e.key) {
            case 'Escape':
                if (this.level2MenuActive) {
                    e.preventDefault();
                    $('.js-hamburger-menu-level-2 .js-hamburger-back-to-level1').trigger('click');
                } else if (this.level3MenuActive) {
                    e.preventDefault();
                    $('.js-hamburger-menu-level-3 .js-hamburger-back-to-level2').trigger('click');
                } else if ($('body').hasClass('nav-active')) {
                    e.preventDefault();
                    window.$document.find('.js-menu-toggle').trigger('click');
                }
                break;
            case 'Tab':
                e.preventDefault();
                this.setNextFocusElement();
                break;
            case 'ArrowRight':
                if ($activeElement.hasClass('js-slider-level2-category') || $activeElement.hasClass('js-slider-level3-category')) {
                    this.triggerNextSlider($activeElement);
                }
                break;
            case 'ArrowLeft':
                if (this.level2MenuActive) {
                    e.preventDefault();
                    $('.js-hamburger-menu-level-2 .js-hamburger-back-to-level1').trigger('click');
                } else if (this.level3MenuActive) {
                    e.preventDefault();
                    $('.js-hamburger-menu-level-3 .js-hamburger-back-to-level2').trigger('click');
                }
                break;
            case 'ArrowDown':
                e.preventDefault();
                this.setNextFocusElement();
                break;
            case 'ArrowUp':
                e.preventDefault();
                this.setPreviousFocusElement();
                break;
            case 'Enter':
                if (e.target.classList.contains('js-flight-details-link')) {
                    e.preventDefault();
                    window.$document.find('.js-flight-details-link').trigger('click');
                }
                break;
            default:
                break;
        }
    }

    initCache() {
        this.level2 = {
            $button: $('.js-hamburger-menu-level-2 .js-hamburger-back-to-level1'),
            $view: $('.js-hamburger-menu-level-2'),
            $title: $('.js-hamburger-menu-level-2-title'),
            $all: $('.js-hamburger-menu-level-2-all'),
            $content: $('.js-hamburger-menu-level-2-content')
        };
        this.level3 = {
            $button: $('.js-hamburger-menu-level-3 .js-hamburger-back-to-level2'),
            $view: $('.js-hamburger-menu-level-3'),
            $title: $('.js-hamburger-menu-level-3-title'),
            $all: $('.js-hamburger-menu-level-3-all'),
            $content: $('.js-hamburger-menu-level-3-content')
        };
        this.mainMenuItems = $('.js-mobile-menu-category > ul > li:not(.js-hamburger-menu-level-2, .js-hamburger-menu-level-3) > a, .js-mobile-menu-category > ul > li:not(.js-hamburger-menu-level-2, .js-hamburger-menu-level-3) > button, .js-root-item > a');
        this.level2MenuActive = false;
        this.level3MenuActive = false;
        this.level1FocusedElement = null;
        this.level2FocusedElement = null;
    }

    showLevel2 (item) {
        let topCatName = $(item).attr('data-name');
        let topCatLink = $(item).attr('data-link');
        let topId = $(item).attr('data-id');
        let content = `<ul id="mobile-menu2-${topId}" class="b-header-category__list" aria-labelledby="mobile-menu1-${topId}" role="menu">`;
        let $level2Category = $(`.js-slider-level2[data-name="${topCatName}"] .js-slider-level2-item`);

        $level2Category.each((i, el) => {
            content += '<li class="b-header-category__link-wrap">' + $(el).find('.js-slider-level2-link').html() +
                       ($(el).find('.js-slider-level2-next').length > 0 ? $(el).find('.js-slider-level2-next').html() : '') +
                       '</li>';
        });

        let $level2Wrapper = $level2Category.closest('.js-main-content-wrap');

        if ($level2Wrapper.length > 0) {
            content += '<li class="b-banner__category-item">' + $level2Wrapper.find('.js-mobile-slot-holder-level2').html() + '</li>';
        }

        content += '</ul>';

        this.level2.$button.attr('aria-controls', 'mobile-menu');
        this.level2.$title.text(topCatName);
        this.level2.$all.text(topCatName);
        this.level2.$all.parent().attr('href', topCatLink);
        this.level2.$content.html(content);
        this.level2.$view.removeClass('slider-collapsed');
        this.level2.$view.addClass('active');
        this.level2MenuActive = true;
        let $topLevelItem = $(item).prev();
        $topLevelItem.attr('aria-expanded', 'true');
        this.level1FocusedElement = $topLevelItem.get(0);
        this.setNextFocusElement();

        // click on back should play only one time per view showing
        $('.js-hamburger-menu-level-2 .js-hamburger-back-to-level1').one('click', () => {
            this.level2.$view.addClass('slider-collapsed');
            this.level2.$view.removeClass('active');
            this.level2MenuActive = false;

            if (this.level1FocusedElement) {
                this.level1FocusedElement.focus();
                $(this.level1FocusedElement).attr('aria-expanded', 'false');
            } else {
                this.setNextFocusElement();
            }
        });
        // add event listener for every next link to show level3
        this.event('click', '.js-slider-level3', this.showLevel3);
        this.event('click', '.js-slider-level3-category', this.triggerNextSlider);
    }

    showLevel3 (item) {
        let topCatName = $(item).attr('data-name');
        let parentCatName = $(item).attr('data-parent');
        let topCatLink = $(item).attr('data-link');
        let topId = $(item).attr('data-id');
        let parentId = $(item).attr('data-parent-id');
        let content = `<ul id="mobile-menu3-${topId}" class="b-header-category__list" aria-labelledby="mobile-menu2-${topId}" role="menu">`;

        let $level3Category = $(`.js-slider-level3-wrap[data-name="${topCatName}"][data-parent="${parentCatName}"] .js-slider-level3-item`);

        $level3Category.each((i, el) => {
            content += '<li class="b-header-category__link-wrap">' + $(el).find('.js-slider-level3-link').html() + '</li>';
        });

        let $level3Wrapper = $level3Category.closest('.js-slider-level2-item');

        if ($level3Wrapper.length > 0) {
            content += '<li class="b-banner__category-item">' + $level3Wrapper.find('.js-mobile-slot-holder-level3').html() + '</li>';
        }

        content += '</ul>';

        this.level3.$button.attr('aria-controls', `mobile-menu2-${parentId}`);
        this.level3.$title.text(topCatName);
        this.level3.$all.text(topCatName);
        this.level3.$all.parent().attr('href', topCatLink);
        this.level3.$content.html(content);
        this.level3.$view.removeClass('slider-collapsed');
        this.level3.$view.addClass('active');
        this.level2.$view.removeClass('active');
        this.level3MenuActive = true;
        this.level2MenuActive = false;
        let $topLevelItem = $(item).prev();
        $topLevelItem.attr('aria-expanded', 'true');
        this.level2FocusedElement = $topLevelItem.get(0);
        this.setNextFocusElement();

        // click on back should play only one time per view showing
        $('.js-hamburger-menu-level-3 .js-hamburger-back-to-level2').one('click', () => {
            this.level3.$view.addClass('slider-collapsed');
            this.level3.$view.removeClass('active');
            this.level2.$view.addClass('active');
            this.level3MenuActive = false;
            this.level2MenuActive = true;

            if (this.level2FocusedElement) {
                this.level2FocusedElement.focus();
                $(this.level2FocusedElement).attr('aria-expanded', 'false');
            } else {
                this.setNextFocusElement();
            }
        });
    }

    triggerNextSlider (item) {
        if (util.isMobile() || $(window).width() < 1224) {
            event.preventDefault();
            $(item).next().trigger('click');
        }
    }
}

module.exports = NavSlider;
